export default __webpack_public_path__ + "static/media/date-picker.45fc162f.svg";